<template>
  <div class="container">
    <head-nav-bar title="排队候诊详情" :fixed="true" />
    <div class="mt-header-nav">
      <div class="">
        <div style="text-align:center;padding: 0.3rem;">
          <div class="color-red" style="font-size:1rem;">
            {{ info.lineUpNo }}
          </div>
          <div class="text-less">排队号</div>
        </div>
        <div class="kong"></div>
        <van-grid border :column-num="3" class="number-card">
          <van-grid-item>
            <div class="value-box">
              <span class="number">{{ info.waitingPatientNumBeforeYou }}</span
              ><span>人</span>
            </div>
            <div class="text-less">在您之前</div>
          </van-grid-item>
          <van-grid-item>
            <div class="value-box">
              <span class="number">{{ info.waitingMinutes }}</span
              ><span>分钟</span>
            </div>
            <div class="text-less">预计候诊时间：</div>
          </van-grid-item>
          <van-grid-item>
            <div class="value-box">
              <span class="number">{{ info.waitingPatientNum }}</span
              ><span>人</span>
            </div>
            <div class="text-less">队列总计</div>
          </van-grid-item>
        </van-grid>

        <van-cell-group class="cell-form">
          <van-field v-model="info.patientName" label="患者姓名：" readonly />
          <van-field
            v-model="info.departmentName"
            label="预约科室："
            readonly
          />
          <van-field v-model="info.doctorName" label="预约医生：" readonly />
          <van-field v-model="info.bookingTime" label="预约时间：" readonly />
          <van-field
            v-model="info.waitingAddress"
            label="候诊地址："
            readonly
          />
        </van-cell-group>
        <div class="kong"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  // ContactList,
  Cell,
  CellGroup,
  Button,
  Popup,
  Checkbox,
  Dialog,
  Field,
  Grid,
  GridItem
} from "vant";

export default {
  name: "Confirm",
  components: {
    [Field.name]: Field,
    // [ContactList.name]: ContactList,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox,
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,

    [Dialog.Component.name]: Dialog.Component
  },
  computed: {
    cardType() {
      return this.contact && this.contact.id ? "edit" : "add";
    }
  },
  data() {
    return {
      // contactId: "",
      visible: {
        agreement: false
      },
      info: {},
      checked: false,
      contact: {},
      showList: false
    };
  },
  created() {
    this.Id = this.$route.query.Id;
    if (this.Id) {
      this.getInfo();
    }
  },
  methods: {
    getInfo() {
      this.$post("LineUp_Info", {
        Id: this.Id
      }).then(res => {
        this.info = res.data;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.text {
  font-size: 0.35rem;
  line-height: 2;
  padding: 0.5rem 0.3rem;
  max-height: 8rem;
  overflow-y: auto;
  color: #555;
}
.number-card {
  font-size: 0.4rem;
  .value-box {
    .number {
      font-size: 0.7rem;
      color: @main-color;
    }
  }
}
</style>
